import { Link } from 'react-router-dom'
import { SecurityAvatar } from '@/securities/securityAvatar'
import { APP_ROUTES } from '@/common/constants'
import { NAVIGATION_COPY } from '@/locales/en'
import { InstrumentSearchRecordT } from '@/common/types'
import { SearchResultsState } from './SearchResultsState'

type Props = {
    searching: boolean
    searchResult: InstrumentSearchRecordT[]
    onResultClick: (security: InstrumentSearchRecordT) => void
}

export function MobileSearchResults({ searching, searchResult, onResultClick }: Props) {
    return (
        <SearchResultsState
            searching={searching}
            items={searchResult}
            emptyMessage={NAVIGATION_COPY.instrumentSearch.noResults}
        >
            {(items) => (
                <div className="w-full divide-y divide-border-outline/60">
                    {items.map((instrument) => (
                        <Link
                            key={instrument.securityCode}
                            to={`${APP_ROUTES.SECURITY}/${instrument.securityCode}`}
                            className="block text-inherit rounded-lg hover:bg-lime-50 transition-colors"
                            onClick={() => onResultClick(instrument)}
                        >
                            <div className="w-full p-2 flex items-center gap-4">
                                <SecurityAvatar
                                    securityCode={instrument.securityCode}
                                    className="!space-x-0"
                                    imgClassName="w-full h-full object-cover"
                                    width={8}
                                    height={8}
                                />
                                <div className="flex-1 flex flex-col justify-center items-start gap-1">
                                    <div className="text-black text-base font-medium leading-6">
                                        {instrument.securityCode}
                                    </div>
                                    <div className="w-full text-content-secondary text-sm font-normal leading-5 line-clamp-1">
                                        {instrument.securityName}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </SearchResultsState>
    )
}
